import { makeAutoObservable } from 'mobx';
import type { Product, Solution, NewsItem, NavItem, Instrument } from '@/types';
import * as mock from '@/data/mockData';

// 콘텐츠 상태. 지금은 목업, 추후 WebSocket으로 백엔드에서 로드.
export class ContentStore {
  loaded = false;

  nav: NavItem[] = [];
  navUtil: string[] = [];
  hero = mock.HERO;
  spotlight = mock.SPOTLIGHT;
  instrumentsSection = mock.INSTRUMENTS_SECTION;
  instruments: Instrument[] = [];
  news: NewsItem[] = [];
  solutions: Solution[] = [];
  products: Product[] = [];
  services = mock.SERVICES;
  trust = mock.TRUST;
  clients = mock.CLIENTS;
  cases = mock.CASES;
  location = mock.LOCATION;
  company = mock.COMPANY;
  companyHero = mock.COMPANY_HERO;         // 회사소개 히어로 슬로건
  companySections = mock.COMPANY_SECTIONS; // 회사소개 서브페이지 앵커 섹션 목록
  greeting = mock.GREETING;                // 인사말(evstech 원문)
  orgChart = mock.ORG_CHART;               // 조직도(evstech 구조 → EVS 벡터 재해석)
  history = mock.HISTORY;                   // 주요연혁 타임라인(evstech)
  talent = mock.TALENT;                     // 인재상(evstech 원문 + EVS SVG 아이콘)
  igm = mock.IGM;                           // 사업소개① IoT GW 제조업(evstech 원문 + 사진 + SVG)
  install = mock.INSTALL;                    // 사업소개② IoTGW설치(방지시설·배출시설·설치대상·설치사례)
  installSections = mock.INSTALL_SECTIONS;   // IoTGW설치 앵커 섹션 목록
  productPage = mock.PRODUCT_PAGE;           // 제품소개(목업 viaportal 다크 디자인 + evstech 제품 실측)
  productSections = mock.PRODUCT_SECTIONS;   // 제품소개 앵커 섹션 목록
  support = mock.SUPPORT;                    // 고객지원(목업 evs.com/contact + evstech 견적문의 실측)
  supportSections = mock.SUPPORT_SECTIONS;   // 고객지원 앵커 섹션 목록
  footerCols = mock.FOOTER_COLS;

  constructor() {
    makeAutoObservable(this);
    this.loadMock();
  }

  // 목업 로드 (백엔드 연동 시 loadFromServer로 대체)
  loadMock() {
    this.nav = mock.NAV;
    this.navUtil = mock.NAV_UTIL;
    this.instruments = mock.INSTRUMENTS;
    this.news = mock.NEWS;
    this.solutions = mock.SOLUTIONS;
    this.products = mock.PRODUCTS;
    this.loaded = true;
  }

  // TODO(backend): wsService.on('content:main', payload => this.applyServer(payload))
}
